import React from 'react';

import { makeListData } from '../utils/list';
import { useLabTestHistoryContext } from '../state/context';

import styles from './index.styl';

export const LabTestHistoryList = () => {
  const { data, pending } = useLabTestHistoryContext();

  const list = makeListData(data);

  return (
    <div className={styles.wrapper}>
      {!pending &&
        list.length > 0 &&
        list.map(l => {
          return (
            <div className={styles.item} key={l.id}>
              <div className={styles.left}>
                {l.left}
                <span className={styles.redText}>{l.leftSuffix}</span>
              </div>
              <div className={styles.right}>{l.right}</div>
            </div>
          );
        })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryList/index.jsx